import { strings } from '../strings'
import '../styling/newBookings.css'


const NewBooking = ({ handleClick }) => {

    return (

        <div className='newBookingContainer'>
            <div className='booking-links'>
                <div className='booking-link' onClick={() => handleClick(1)}>{strings.home.laundry1}</div>
                <div className='booking-link' onClick={() => handleClick(2)}>{strings.home.laundry2}</div>
                <div className='booking-link' onClick={() => handleClick(3)}>{strings.home.laundry3}</div>
                <div className='booking-link' onClick={() => handleClick(4)}>{strings.home.balcony} </div>
            </div>
        </div>

    )
}

export default NewBooking

